import { FC } from "react"
import classNames from "classnames"
import CellDescription from "./CellDescription"
import { useCellCardState } from "./useCellCardState"
import { CellCardProps } from "."
import Badge from "@/components/shared/Badge"
import { Icon } from "@/components/shared/Icon"
import { TestId } from "@/constants/globals"
import { getCellIconName, getCellIconTestId } from "@/utils/cells"
import "./index.scss"

interface CellCardMediumProps extends CellCardProps {
   hasAction?: boolean
   isClickable?: boolean
}

const CellCardMedium: FC<CellCardMediumProps> = ({
   cellId,
   bpm,
   bpmStabilityScore,
   rpm,
   rpmStabilityScore,
   occupied,
   maintenance,
   isCustom,
   hasDoorSensor = false,
   doorSensorLowBattery = false,
   cellStatus: cell,
   userStatus,
   typefaceColor,
   hasAction = false,
   isClickable = false,
   isCollapsed,
   onClick,
}) => {
   const {
      cellStatus,
      hideVitals,
      humanPresenceInVacant,
      noVitals,
      typefaceClassName,
      typefaceIconColor,
   } = useCellCardState({
      cellStatus: cell,
      occupied,
      maintenance,
      typefaceColor,
      userStatus,
   })

   const iconName = getCellIconName(
      isCustom,
      hasDoorSensor,
      doorSensorLowBattery
   )

   return (
      <Badge
         invisible={!hasAction}
         sx={{ width: "100%" }}
      >
         <div
            data-testid={TestId.CELL_CARD}
            className={classNames(
               "cell-card",
               "cell-card--medium",
               `cell-card--${cellStatus}`,
               typefaceClassName,
               {
                  "cell-card--with-status-icon": noVitals,
                  "cell-card--clickable": isClickable,
                  "cell-card--collapsed": isCollapsed,
                  "cell-card--custom": isCustom,
               }
            )}
            onClick={onClick}
         >
            <span className="cell-card__cell-id-wrapper">
               <Icon
                  className={classNames({
                     "cell-card__door-sensor-battery-icon":
                        doorSensorLowBattery,
                  })}
                  size="16"
                  color={typefaceIconColor}
                  name={iconName}
                  data-testid={getCellIconTestId(iconName)}
               />
               <span className="cell-card__cell-id">{cellId}</span>
            </span>
            <CellDescription
               cellStatus={cellStatus}
               userStatus={userStatus}
               noVitals={noVitals}
               humanPresenceInVacant={humanPresenceInVacant}
               {...(!noVitals && bpm && { bpm })}
               bpmStabilityScore={bpmStabilityScore}
               {...(!noVitals && rpm && { rpm })}
               rpmStabilityScore={rpmStabilityScore}
               hideVitals={hideVitals}
               typefaceIconColor={typefaceIconColor}
               iconSize="16"
            />
         </div>
      </Badge>
   )
}

export default CellCardMedium
